module.exports = __webpack_public_path__ + "img/front-body.8e644f97.svg";